import { createSvgIcon } from '../../createSvgIcon';
import { CHEVRON_PATH_D } from '../chevronPath';

export const ChevronRightIcon = createSvgIcon(<path d={CHEVRON_PATH_D} fill="currentColor" />, {
  displayName: 'ChevronRightIcon',
  viewBox: '0 0 15 27'
});
